import React from "react";
import { css } from "emotion";
import AddRow from "./AddRow";
import { boxStyles } from "../../styles/theme";
import OverviewList from "./OverviewList";

const HomeBody = () => {
  return (
    <div className={container}>
      <AddRow />
      <OverviewList />
    </div>
  );
};

export default HomeBody;

const container = css`
  padding: ${boxStyles.standardPadding};
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: 0;
  }
`;
